import { TFunction } from "i18next";
import { ApiError } from "../request/salesforce/make-sf-call";

export function isTaskReassignPermissionError(error: ApiError): boolean {
  return error.message.includes("You do not have permission to reassign tasks");
}

export function getTaskApiErrorMessage(error: ApiError, t: TFunction): string {
  if (isTaskReassignPermissionError(error)) {
    return t("task_error_reassign_permission");
  }
  return error.message;
}
